import { useHydrating } from "eddev/routing"
import { useEffect, useRef } from "react"

type SensorProps = {
  onActivate: () => void
  detectScrollPast?: boolean
}

export function ScrollSensor(props: SensorProps) {
  const hydrating = useHydrating()
  const ref = useRef<HTMLDivElement>(null)
  const onActivate = useRef(props.onActivate)
  onActivate.current = props.onActivate

  useEffect(() => {
    const el = ref.current!
    if (hydrating || !el) return
    let lastValue = false
    const observer = new IntersectionObserver((entries) => {
      const isIntersecting = entries[0].isIntersecting
      if (isIntersecting && !lastValue) {
        onActivate.current()
      }
      lastValue = isIntersecting
    })
    observer.observe(el)

    const interval = setInterval(() => {
      const isIntersecting = el.getBoundingClientRect().top < 0
      if (isIntersecting && !lastValue) {
        onActivate.current()
      }
      lastValue = isIntersecting
    }, 1000)

    return () => {
      observer.disconnect()
      clearInterval(interval)
    }
  }, [hydrating])

  if (hydrating) return null
  return <div className="h-1 w-1" ref={ref}></div>
}
